var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 462,
        visible: _vm.visible,
        footer: null
      },
      on: { cancel: _vm.handleCancel }
    },
    [
      _c("div", { staticClass: "product-detail-root" }, [
        _c("div", { staticClass: "product-swiper" }, [
          _vm.images && _vm.images.length > 0
            ? _c("img", {
                attrs: { width: "100%", height: "316", src: _vm.images[0] }
              })
            : _vm._e()
        ]),
        _c("div", { staticClass: "product-content" }, [
          _c(
            "div",
            { staticClass: "product-tags" },
            _vm._l(_vm.tags, function(i) {
              return _c("span", { key: i, staticClass: "product-tag" }, [
                _vm._v(_vm._s(i))
              ])
            }),
            0
          ),
          _c("div", { staticClass: "product-name" }, [
            _vm._v("\n          " + _vm._s(_vm.record.name) + "\n        ")
          ]),
          _c("div", { staticClass: "product-shop" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.record.supplierName) + "\n        "
            )
          ]),
          _c("div", { staticClass: "product-field" }, [
            _c("div", { staticClass: "product-price" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "currentColor",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    size: "16",
                    color: "#D5A85F",
                    "data-v-5d0cdcb4": ""
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "ic-honhaimoney-red",
                        transform: "translate(0 0.296)"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "Subtraction_9",
                          "data-name": "Subtraction 9",
                          d:
                            "M-2494,2102.7a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8A8.009,8.009,0,0,1-2494,2102.7Zm-1.508-7.333h3.015v3.333h1.993v-8h-1.993v3.179h-3.015V2090.7h-1.992v8h1.992v-3.333Z",
                          transform: "translate(2502 -2087)"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(
                "\n            " + _vm._s(_vm.record.price) + "\n          "
              )
            ]),
            _c("div", { staticClass: "product-stock" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "currentColor",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    size: "16",
                    color: "#0c52a7",
                    "data-v-27567401": ""
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "ic-honhaimoney",
                        transform: "translate(0 0.296)"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "Subtraction_9",
                          "data-name": "Subtraction 9",
                          d:
                            "M-2494,2102.7a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8A8.009,8.009,0,0,1-2494,2102.7Zm-4.1-9.448h0v3.394a.913.913,0,0,0,.456.788l2.958,1.691v-3.9l-3.415-1.975Zm8.194,0h0l-3.413,1.975v3.9l2.957-1.691a.914.914,0,0,0,.456-.788v-3.394Zm-4.1-2.975a.912.912,0,0,0-.455.121l-2.942,1.681,3.4,1.965,3.4-1.965-2.943-1.681A.914.914,0,0,0-2494,2090.281Z",
                          transform: "translate(2502 -2087)"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.record.virtual == 0
                      ? "尚餘數量 1000組"
                      : "捐助總額 1000元"
                  ) +
                  "\n          "
              )
            ])
          ]),
          _c("div", { staticClass: "product-driver" }),
          _c("div", { staticClass: "product-introduce" }, [
            _c("h5", { staticClass: "product-introduce-title" }, [
              _vm._v(_vm._s("產品介紹"))
            ]),
            _vm.record.description
              ? _c("p", {
                  staticClass: "product-introduce-text",
                  domProps: {
                    innerHTML: _vm._s(_vm.record.description || "--")
                  }
                })
              : _vm._e(),
            _vm.record.virtual == 0
              ? _c("dl", { staticClass: "product-introduce-attr" }, [
                  _c("dt", { staticClass: "product-attr-label" }, [
                    _vm._v("內容物重量(g)")
                  ]),
                  _c("dd", {
                    staticClass: "product-attr-value",
                    domProps: { innerHTML: _vm._s(_vm.record.weight || "--") }
                  })
                ])
              : _vm._e(),
            _vm.record.virtual == 0
              ? _c("dl", { staticClass: "product-introduce-attr" }, [
                  _c("dt", { staticClass: "product-attr-label" }, [
                    _vm._v("外盒尺寸長*寬*高 (cm)")
                  ]),
                  _c("dd", {
                    staticClass: "product-attr-value",
                    domProps: {
                      innerHTML: _vm._s(
                        (_vm.record.length || "--") +
                          "*" +
                          (_vm.record.width || "--") +
                          "*" +
                          (_vm.record.height || "--")
                      )
                    }
                  })
                ])
              : _vm._e(),
            _vm.record.virtual == 0
              ? _c("dl", { staticClass: "product-introduce-attr" }, [
                  _c("dt", { staticClass: "product-attr-label" }, [
                    _vm._v("有效日期")
                  ]),
                  _c("dd", {
                    staticClass: "product-attr-value",
                    domProps: {
                      innerHTML: _vm._s(_vm.record.validityPeriod || "--")
                    }
                  })
                ])
              : _vm._e(),
            _vm.record.virtual == 0
              ? _c("dl", { staticClass: "product-introduce-attr" }, [
                  _c("dt", { staticClass: "product-attr-label" }, [
                    _vm._v("成分")
                  ]),
                  _c("dd", {
                    staticClass: "product-attr-value",
                    domProps: {
                      innerHTML: _vm._s(_vm.record.ingredient || "--")
                    }
                  })
                ])
              : _vm._e(),
            _vm.record.virtual == 0
              ? _c("dl", { staticClass: "product-introduce-attr" }, [
                  _c("dt", { staticClass: "product-attr-label" }, [
                    _vm._v("產地")
                  ]),
                  _c("dd", {
                    staticClass: "product-attr-value",
                    domProps: { innerHTML: _vm._s(_vm.record.origin || "--") }
                  })
                ])
              : _vm._e(),
            _vm.record.virtual != 0
              ? _c("a", { staticClass: "product-introduce-link" }, [
                  _vm._v("\n            我想以點數捐助此商家\n            "),
                  _c(
                    "svg",
                    {
                      staticClass: "ml-1",
                      attrs: {
                        id: "icon-24-calendar-right",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "currentColor",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          id: "Rectangle_9137",
                          "data-name": "Rectangle 9137",
                          width: "24",
                          height: "24",
                          fill: "rgba(255,255,255,0.01)"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          id: "Union_399",
                          "data-name": "Union 399",
                          d:
                            "M-5519.707-108.293a1,1,0,0,1,0-1.415l4.293-4.293H-5531a1,1,0,0,1-1-1,1,1,0,0,1,1-1h15.587l-4.293-4.294a1,1,0,0,1,0-1.413,1,1,0,0,1,1.414,0l6,6a1,1,0,0,1,.2.295l0,.005.006.014.006.015v0A1,1,0,0,1-5512-115a1,1,0,0,1-.3.714l-5.993,5.993A1,1,0,0,1-5519-108,1,1,0,0,1-5519.707-108.293Z",
                          transform: "translate(5534.101 127)",
                          fill: "#ef7555"
                        }
                      })
                    ]
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }